export const NOT_TRANSLATED_SUB_PAGES: ReadonlyArray<string> = [
  'articles/',
  'glossary/',
  'events/',
  '/apply-qr',
];

export const ROUTES_WITH_DISABLED_LANG_SWITCHER: ReadonlyArray<string> = [
  'articles/',
];

export const PAGES_WITHOUT_TRANSLATION: ReadonlyArray<string> = [
  'glossary',
  'risk-appetite-policy',
  'aml-cft-policies',
  'toc',
  'legal-privacy',
  'qr-code-payments',
  'stream-donations',
];

export const NON_PUBLIC_PAGES: ReadonlyArray<string> = [
  '404',
  'contact-sales',
  'apply-qr',
  'rules/processing',
  'rules/internal',
  'toc',
];
